import { useEffect, useState } from 'react'
import { closeModal } from "../helpers/useModal";
import { CloseIcon } from "../icons/CloseIcon";

type props = {
  id: string
  className?: string
  heading?: string
  content: React.ReactNode,
  type?: string,
  scrollTarget?: string
  renderOnOpen?: boolean
}

export function Modal ({ id, className, heading, content, type = 'modal', scrollTarget = '.modal-body', renderOnOpen = false }: props) {
  if (!id) return null

  const [hasRenderedContent, setHasRenderedContent] = useState(!renderOnOpen)

  useEffect(() => {
    if (!renderOnOpen) {
      return
    }

    const handleOpen = () => {
      setHasRenderedContent(true)
    }

    document.addEventListener(`open-${id}`, handleOpen)

    return () => {
      document.removeEventListener(`open-${id}`, handleOpen)
    }
  }, [id, renderOnOpen])

  const close = () => {
    closeModal(id)
    sessionStorage.removeItem('returnTo')
  }

  return (
    <div className={`modal ${className}`} id={id} data-modal={type} data-scroll-target={scrollTarget}>
      <div className="modal-overlay" onClick={close}></div>
      <div className="modal-body">
        <div className="modal-header">
          <div className="modal-header-tab z-50"></div>
          <h2 className="modal-heading">{heading}</h2>
          <button className="modal-close" aria-label="close-modal" onClick={close}>
            <CloseIcon />
          </button>
        </div>
        <div className="modal-content">
          {hasRenderedContent ? content : null}
        </div>
      </div>
    </div>
  )
}
